export const currentYear = new Date().getFullYear();

export const getYearOptions = () => {
  const startYear = 2020;
  let currentYear = new Date().getFullYear();
  const dataYears = [];

  while (startYear <= currentYear) {
    const year = (currentYear--).toString();
    dataYears.push({
      label: year,
      value: year,
    });
  }

  return dataYears;
};

export const selectedYearOption = {
  value: currentYear.toString(),
  label: currentYear.toString(),
};
